import { makeStyles } from "@material-ui/core/styles";

import { colors } from "@utils/constant";

const surchargeUpdateStyle = makeStyles((theme) => ({
  surchargeUpdateWrapper: {},
  dialogContentText: {
    fontWeight: "700",
    color: "#212121",
  },
  customModal: {
    "& .MuiDialog-paperScrollPaper": {
      boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "40px",
      maxWidth: "650px",
      width: "100%",
      "@media(max-width:767px)": {
        maxWidth: "100%",
        padding: "25px 15px",
        margin: "0 15px",
      },
      "& .MuiDialogContent-root,& .MuiDialogActions-root, & .MuiDialogTitle-root":
      {
        padding: "0",
        justifyContent: "center",
      },
      "& .MuiDialogTitle-root": {
        "& .MuiTypography-root": {
          fontWeight: "700",
          fontSize: "24px",
          lineHeight: "1.321",
          color: colors.black,
          marginBottom: "40px",
          "& img": {
            display: "block",
            margin: "0 auto 20px",
          },
        },
      },
      "& .MuiDialogContent-root": {
        "& .MuiTypography-root": {
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "1.44",
          color: colors.black,
          maxWidth: "300px",
          margin: "0 auto 15px",
        },
      },
      "& .MuiDialogContent-root.add-surcharge": {
        height: "auto",
        overflow: "visible",
        marginBottom: "20px",
        "& .div-wrapper": {
          "& .MuiFormControlLabel-root": {
            display: "flex",
            flex: 1,
            justifyContent: "start",
            "& .MuiTypography-root": {
              margin: 0
            }
          }
        }
      },
      "& .MuiDialogActions-root": {
        justifyContent: "space-between",
        "& button": {
          maxWidth: "165px",
          width: "100%",
          height: "50px",
          lineHeight: "50px",
          fontSize: "16px",
          fontWeight: "600",
          textTransform: "uppercase",
          transition: "all 0.3s",
          "@media(max-width:374px)": {
            padding: "0 8px",
          },
        },
        "& button.btn-add-surcharge": {
          maxWidth: "200px",
        },
        "& button + button": {
          marginLeft: "20px",
          "@media(max-width:767px)": {
            marginLeft: "15px",
          },
        },
      },
    },

    "& .MuiDialogContent-root.gird-surcharge": {
      overflow: "visible",
    },

    "& .title": {
      textAlign: "start",
    },
    "& .close-modal": {
      position: "absolute",
      right: "40px",
      top: "45px",
      cursor: "pointer",
      "@media (max-width: 991px)": {
        top: "28px",
        right: "25px",
      },
    },
    "& .btn-wrapper": {
      display: "flex",
      marginTop: "10px",
      justifyContent: "center",
      flexWrap: "wrap",
    },
  },

  customModalRestoreSurcharge: {
    "& .MuiDialog-paperScrollPaper": {
      boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "40px",
      maxWidth: "520px",
      width: "100%",
      "@media(max-width:767px)": {
        maxWidth: "100%",
        padding: "25px",
        margin: "0 15px",
      },
      "& .MuiDialogContent-root,& .MuiDialogActions-root, & .MuiDialogTitle-root":
      {
        padding: "0",
        justifyContent: "center",
      },
      "& .MuiDialogContent-root": {
        "& .MuiTypography-root": {
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "1.44",
          color: colors.black,
          maxWidth: "100%",
          margin: "0 auto 30px",
          textAlign: "center",
        },
      },
      "& .MuiDialogActions-root": {
        "& button": {
          width: "100%",
          height: "50px",
          lineHeight: "50px",
          fontSize: "16px",
          fontWeight: "600",
          textTransform: "uppercase",
          transition: "all 0.3s",
        },
      },
    },
    "& .close-modal": {
      position: "absolute",
      right: "20px",
      top: "20px",
      cursor: "pointer",
      "@media (max-width: 767px)": {
        top: "10px",
        right: "12px",
      },
    },
  },
  TableWrapper: {
    "& .MuiBackdrop-root": {
      color: " #fff",
      zIndex: "1201",
    },
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: "6px",
  },
  customTable: {
    marginTop: 25,
    maxHeight: 450,
    boxShadow: "none",
    borderTop: "1px solid rgba(33, 33, 33, 0.3)",
    "& .MuiTable-root": {
      minWidth: 550,
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
        wordBreak: "break-word",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "10px",
          textAlign: "center",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
        },
        "& .MuiTableCell-head": {
          fontWeight: 700,
          color: colors.black,
        }
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "10px",
          textAlign: "center",
        },
      },
      "& .name": {
        width: "200px",
      },
      "& .date": {
        width: "100px",
      },
      "& .isAWBLevel": {
        width: "100px",
        "& .MuiSwitch-root": {
          marginLeft: "20px",
          "& .MuiTypography-root": {
            margin: 0
          }
        }
      },
      "& .delete-link": {
        width: "65px",
        "& span": {
          color: colors.red,
          textTransform: "capitalize",
          cursor: "pointer",
        },
      },
    },
  },
}));

export { surchargeUpdateStyle };
